import { HttpError } from 'react-admin';
import { enqueueSnackbar } from 'notistack';
import { getReasonPhrase } from 'http-status-codes';

function parseQueryKey(
  mainKey,
  transformKeys: { [key: string]: string } = { auth: 'Authorization' }
) {
  if (!mainKey) return '';
  if (transformKeys[mainKey]) return transformKeys[mainKey];
  return mainKey.charAt(0).toUpperCase() + mainKey.slice(1);
}

export const httpErrorValidation = (
  error: HttpError | Error,
  query: any,
  transformKeys?: { [key: string]: string }
) => {
  if (error instanceof HttpError) {
    const errors = error?.body?.errors;
    const status = getReasonPhrase(error?.status);
    let mainKey;
    if (query.constructor.name?.includes?.('Mutation')) {
      mainKey = query.options.variables.resource
        ? query.options.variables.resource
        : Array.isArray(query.options.mutationKey)
        ? query.options.mutationKey[0]
        : query.options.mutationKey;
    } else if (query.constructor.name?.includes?.('Query')) {
      mainKey = Array.isArray(query.queryKey) ? query.queryKey[0] : query.queryKey;
    }
    if (errors) {
      errors.forEach((networkError) => {
        const pointer = networkError.source?.pointer;
        console.log(parseQueryKey(mainKey, transformKeys));
        enqueueSnackbar(
          `${
            parseQueryKey(mainKey, transformKeys)
              ? `Error occurred in ${parseQueryKey(mainKey, transformKeys)}. `
              : ''
          }${networkError.title}${
            networkError.title
              ? networkError.title.slice(-1).includes('.')
                ? ' '
                : '. '
              : ''
          }${networkError.detail}${
            networkError.detail
              ? networkError.detail.slice(-1).includes('.')
                ? ' '
                : '. '
              : ''
          }Reason: ${status}.${pointer ? ` Incorrect field: ${pointer}.` : ''}`,
          {
            variant: 'error',
          }
        );
      });
    }
  }
};
